import type { ListingRun } from "@nova-ai/shared"
import { RunsTable } from "./runs-table"

export function RunsResults({
  runs,
  isLoading,
  error,
  showStatus,
  onClear,
  onRetry,
}: {
  runs: readonly ListingRun[]
  isLoading: boolean
  error: Error | null
  showStatus: boolean
  onClear: () => void
  onRetry: () => void
}) {
  if (isLoading) {
    return (
      <div className="p-4" aria-label="Loading runs">
        <div className="mb-3 h-12 animate-pulse rounded-lg bg-muted [animation-duration:1.2s] [animation-timing-function:ease-in-out] motion-reduce:animate-none" />

        <div className="mb-3 h-12 animate-pulse rounded-lg bg-muted [animation-duration:1.2s] [animation-timing-function:ease-in-out] motion-reduce:animate-none" />

        <div className="mb-3 h-12 animate-pulse rounded-lg bg-muted [animation-duration:1.2s] [animation-timing-function:ease-in-out] motion-reduce:animate-none" />
      </div>
    )
  }
  if (error) {
    return (
      <div className="px-5 py-12 text-center text-muted-foreground" role="alert">
        <p className="mb-3">Runs could not be loaded.</p>

        <button
          type="button"
          className="inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-full border border-border bg-card px-3 text-[13px] font-medium whitespace-nowrap text-foreground focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2"
          onClick={onRetry}
        >
          Try again
        </button>
      </div>
    )
  }
  if (runs.length === 0) {
    return (
      <div className="px-5 py-12 text-center text-muted-foreground">
        <p className="mb-3">No runs match these filters.</p>

        <button
          type="button"
          className="inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-full border border-border bg-card px-3 text-[13px] font-medium whitespace-nowrap text-foreground focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2"
          onClick={onClear}
        >
          Clear filters
        </button>
      </div>
    )
  }
  return <RunsTable runs={runs} showStatus={showStatus} />
}
